import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getProgress } from '../services/api';
import BrandLogo from '../components/wizard/BrandLogo';
import { computeRequestedDocuments } from '../components/wizard/requestedDocs';

/**
 * Shown after the client submits the completed FPR update form.
 *
 * Surfaces a summary of any documents the advisor will need based on
 * the client's responses, plus a link to the secure Client Portal where
 * they can upload them.
 */
export default function CompletePage() {
  const { client, logout } = useAuth();
  const [docs, setDocs] = useState([]);
  const [portalUrl, setPortalUrl] = useState('');
  const [clientType, setClientType] = useState('hff');

  useEffect(() => {
    getProgress()
      .then((data) => {
        setDocs(computeRequestedDocuments(data.form_data || {}));
        setPortalUrl(data.client_portal_url || '');
        setClientType(data.client_type || 'hff');
      })
      .catch(() => { /* non-fatal */ });
  }, []);

  const isRebelClient = clientType === 'rebellionaire';
  const themeClass = isRebelClient ? 'theme-rebellionaire' : '';

  return (
    <div className={`cashflow-login-bg d-flex justify-content-center align-items-center min-vh-100 py-4 ${themeClass}`}>
      <div className="card shadow-sm p-4" style={{ maxWidth: 640, width: '100%' }}>
        <div className="text-center">
          <BrandLogo size={64} className="mb-3" />
          <h2 className="h4 fw-bold cashflow-brand-text mb-2">
            Thank You{client?.name ? `, ${client.name.split(' ')[0]}` : ''}!
          </h2>
          <p className="text-muted mb-4">
            Your Financial Planning Review update has been submitted. Your
            advisor will review your responses before your upcoming meeting.
          </p>
        </div>

        {docs.length > 0 && (
          <div className="alert alert-light border-start border-4 border-danger py-3">
            <h6 className="fw-bold mb-2">
              <i className="bi bi-paperclip me-2 text-danger" />
              Documents to upload
            </h6>
            <p className="small text-muted mb-2">
              Based on your responses, please upload the following to your
              secure Client Portal:
            </p>
            <ul className="mb-3 small ps-3">
              {docs.map((d) => (
                <li key={d}>{d}</li>
              ))}
            </ul>
            {portalUrl && (
              <a
                href={portalUrl}
                className="btn btn-danger btn-sm"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-cloud-upload me-1" />
                Open Client Portal
              </a>
            )}
          </div>
        )}

        <div className="d-flex gap-2 justify-content-center flex-wrap mt-3">
          <Link to="/wizard" className="btn btn-outline-secondary">
            <i className="bi bi-pencil me-1" />
            Review My Answers
          </Link>
          <button className="btn btn-outline-danger" onClick={logout}>
            <i className="bi bi-box-arrow-right me-1" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
